import React from 'react';
import Table from '../../components/common/Table';
import { EndorsementMotivationDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface EndorsementMotivationTableProps {
  data: EndorsementMotivationDTO[];
  handleEdit: (row: EndorsementMotivationDTO) => void;
  handleDelete: (row: EndorsementMotivationDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const EndorsementMotivationTable: React.FC<EndorsementMotivationTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },

        {
          label: 'Colour',
          key: 'colour',
          render: (row: EndorsementMotivationDTO) => (
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{
                  backgroundColor: row.colourGrading?.colour ?? '#ffffff',
                }}
              />
              <span className="text-sm text-slate-600 dark:text-slate-300">
                {row.colourGrading?.title ?? '-'}
              </span>
            </div>
          ),
        },

        {
          label: 'Position',
          key: 'displayPosition',
        },

        {
          label: 'Active',
          key: 'isActive',
          render: (row: EndorsementMotivationDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default EndorsementMotivationTable;
